import $ from 'jquery';
// import 'owl.carousel';

class Accommodation {
  constructor() {
    this.isAccommodationPage = $('.js-accommodation-page').length;
    this.carousel = $('.owl-carousel');

    if (!this.isAccommodationPage || !this.carousel.length) {
      return;
    }

    import('owl.carousel').then(() => {
      this.carouselArgs = {};

      this.setCarouselArgs();

      this.carouselInit();
    });
  }

  setCarouselArgs() {
    this.carouselArgs = {
      margin: 20,
      nav: true,
      dots: true,
      navText: [
        '<svg class="c-icon c-icon--angle-left"><use xlink:href="#c-icon--angle-left"></use></svg>',
        '<svg class="c-icon c-icon--angle-right"><use xlink:href="#c-icon--angle-right"></use></svg>',
      ],
      rewind: true,
      autoHeight: true,
      responsive: {
        0: {
          items: 1,
        },
        600: {
          items: 2,
        },
        768: {
          items: 3,
        },
      },
    };
  }

  carouselInit() {
    this.accommodationCarousel = $('.js-accommodations-carousel');

    if (this.accommodationCarousel.length) {
      this.accommodationCarousel.owlCarousel(this.carouselArgs);
    }
  }
}

export default new Accommodation();



// WEBPACK FOOTER //
// ./src/scripts/modules/accommodation.js